import React from "react";
import { motion } from "framer-motion";
import SoundPattern from "../components/SoundPattern";
import StepSequencer from "../components/StepSequencer";

export default function LearningMusic() {
  return (
    <motion.section
      className="page-inner"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-3xl">
        <div className="mono-label mb-4">Learning Music</div>
        <h1 className="font-sans text-[28px] sm:text-[32px] font-medium tracking-[-0.024em] leading-[1.15] text-[var(--text)]">
          Interactive tools for exploring sound.
        </h1>
        <p className="mt-5 font-sans text-[15px] leading-[1.7] text-[var(--text-secondary)] max-w-[34rem]">
          Drag the waveform to reshape it and hear the result. Use the step sequencer to build rhythms.
        </p>

        <div className="mt-14 space-y-12">
          <div>
            <p className="mono-label mb-4">Waveform</p>
            <SoundPattern />
          </div>

          <div>
            <p className="mono-label mb-4">Step Sequencer</p>
            <StepSequencer />
          </div>
        </div>
      </div>
    </motion.section>
  );
}
